var optionGroup = document.querySelectorAll('fieldset');

function initialize() {                         
  optionGroup.forEach(function(fieldset) {
    var thisOption = fieldset.querySelector('.selectedOption');
    var selectedRadio = fieldset.querySelector('input[type="radio"]:checked');

    if (selectedRadio) {
      thisOption.textContent = " • " + selectedRadio.value;
    }
  });
}

optionGroup.forEach(function(fieldset) {          
  var thisOption = fieldset.querySelector('.selectedOption');
  var radios = fieldset.querySelectorAll('input[type="radio"]');

  fieldset.addEventListener('click', function(event) {
    var target = event.target;

    if (target.type === 'radio') {
      var selectedRadio = target.value;
      thisOption.textContent = " • " + selectedRadio;
    }
  });
});

window.addEventListener('load', initialize);